import { useContext } from "react";
import { AppContext } from "../App";

export default function HomeBanner4() {
  const appContext = useContext(AppContext);

  const coreServices = [
    "Discovery & planning",
    "UI & UX design",
    "Development",
    "Testing & QA",
    "Deployment and support",
  ];

  const addOns = [
    "Cloud hosting and deployment",
    "Maintenance and updates",
    "Admin dashboards",
    "Payment gateway integration",
    "SMS and Email automation",
  ];

  return (
    <section className="pr-section">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-8">
            <span className="pr-eyebrow">TRANSPARENT INVESTMENT</span>
            <h2 className="pr-title">Simple, Flexible Pricing</h2>
            <p className="pr-subtitle">
              Clean, flexible pricing based on scope, features, and complexity. No hidden fees.
            </p>
          </div>
        </div>

        <div className="row g-4 align-items-stretch">
          <div className="col-lg-7">
            <div className="pr-card pr-card-main">
              <div className="pr-card-inner">
                <div className="pr-card-tag">Most Requested</div>
                <h3 className="pr-card-heading">Custom Application Development</h3>

                <div className="pr-price-block">
                  <span className="pr-price-label">Starting from</span>
                  <div className="pr-price-value">2,000,000 <small>TZS</small></div>
                </div>

                <div className="pr-services-grid">
                  {coreServices.map((item, index) => (
                    <div key={index} className="pr-service-pill">
                      <span className="pr-dot"></span> {item}
                    </div>
                  ))}
                </div>

                <button
                  className="pr-btn-primary"
                  onClick={() => appContext.navTo({ item: "contact_us" })}
                >
                  Request a Quote
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="pr-card pr-card-alt">
              <div className="pr-card-inner">
                <h3 className="pr-card-heading-alt">Optional Add-ons</h3>
                <p className="pr-card-text">
                  Extend your product with operational and growth-focused features tailored to your needs.
                </p>

                <div className="pr-addons-list">
                  {addOns.map((item, index) => (
                    <div key={index} className="pr-addon-item">
                      <div className="pr-addon-check" aria-hidden="true">&#10003;</div>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>

                <div className="pr-card-footer">
                  <p className="small mb-0 opacity-75">
                    * Final pricing depends on scope, integrations, and delivery timeline.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .pr-section {
          padding: 100px 0;
          background: #ffffff;
        }

        .pr-eyebrow {
          color: #e88a1c;
          font-weight: 800;
          font-size: 0.75rem;
          letter-spacing: 2px;
          display: block;
          margin-bottom: 12px;
        }

        .pr-title {
          font-size: clamp(2.2rem, 5vw, 3rem);
          font-weight: 800;
          color: #1a1a2e;
          letter-spacing: -0.03em;
          line-height: 1.1;
        }

        .pr-subtitle {
          font-size: 1.1rem;
          color: #64748b;
          margin-top: 15px;
          max-width: 500px;
        }

        .pr-card {
          border-radius: 4px;
          height: 100%;
          position: relative;
          overflow: hidden;
        }

        .pr-card-inner {
          padding: 50px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .pr-card-main {
          background: #1a1a2e;
          color: white;
        }

        .pr-card-tag {
          position: absolute;
          top: 20px;
          right: 20px;
          background: #e88a1c;
          color: white;
          padding: 4px 12px;
          font-size: 0.7rem;
          font-weight: 700;
          text-transform: uppercase;
          border-radius: 2px;
        }

        .pr-card-heading {
          font-size: 1.8rem;
          font-weight: 800;
          margin-bottom: 30px;
          color: white;
        }

        .pr-price-block {
          margin-bottom: 40px;
        }

        .pr-price-label {
          font-size: 0.85rem;
          opacity: 0.6;
          display: block;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .pr-price-value {
          font-size: 2.8rem;
          font-weight: 800;
          color: #e88a1c;
        }

        .pr-price-value small {
          font-size: 1rem;
          color: white;
          opacity: 0.5;
        }

        .pr-services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
          margin-bottom: 40px;
        }

        .pr-service-pill {
          background: rgba(255, 255, 255, 0.05);
          padding: 10px 15px;
          font-size: 0.85rem;
          border-radius: 2px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .pr-dot {
          width: 6px;
          height: 6px;
          background: #e88a1c;
          border-radius: 50%;
        }

        .pr-card-alt {
          background: #f8f9fa;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .pr-card-heading-alt {
          font-weight: 800;
          font-size: 1.5rem;
          color: #1a1a2e;
          margin-bottom: 15px;
        }

        .pr-card-text {
          color: #64748b;
          font-size: 0.95rem;
          margin-bottom: 30px;
        }

        .pr-addons-list {
          margin-bottom: auto;
        }

        .pr-addon-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
          font-size: 0.95rem;
          font-weight: 600;
          color: #1a1a2e;
        }

        .pr-addon-check {
          color: #e88a1c;
          font-weight: 900;
        }

        .pr-btn-primary {
          background: #e88a1c;
          color: white;
          border: none;
          padding: 16px 32px;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 0.85rem;
          letter-spacing: 1px;
          border-radius: 2px;
          transition: all 0.3s ease;
          width: fit-content;
        }

        .pr-btn-primary:hover {
          background: #cf7610;
          transform: translateY(-2px);
        }

        .pr-card-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid rgba(0, 0, 0, 0.05);
          color: #64748b;
        }

        @media (max-width: 768px) {
          .pr-section {
            padding: 60px 0;
          }

          .pr-card-inner {
            padding: 30px;
          }

          .pr-price-value {
            font-size: 2.2rem;
          }
        }
      `}</style>
    </section>
  );
}
